import React from 'react';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';
import AppCard from '../../../../../components/ui/AppCard';
import legalBGImage2 from '../../../../../assets/images/patterns/applyGrouplegalPolicy.png';

export default function NewLifeApplicationPolicyDisplay({ applicationDetail }) {
  const history = useHistory();
  return (
    <div className="grid grid-cols-1 mb-8">
      <AppCard headerImg={legalBGImage2}>
        <div className="flex flex-col text-center justify-center">
          <h3 className="text-xl font-bold mb-3">Get life assurance now!</h3>
          <p className="text-sm text-base-content/70 mb-4">
            <strong className="block text-base-content mb-1">For the ones you love</strong>
            Create your life assurance policy today and embrace a peace of mind.
          </p>
          <Button
            className="w-full sm:w-auto mx-auto"
            size="large"
            label={<strong>Apply Now</strong>}
            severity="info"
            rounded
            outlined
            raised
            onClick={() => {
              history.push("/apply-policy?category=Funeral policy");
            }}
          />
        </div>
      </AppCard>
    </div>
  );
}
